import React, { Component } from 'react'
import { connect } from 'react-redux'
import swal from 'sweetalert'
import axios from 'axios'
import { Table, Button } from 'react-bootstrap'

import { handleErrorFetchingData } from '../../functions/errorHandling'
import getServerURL from '../../functions/getServerURL'

import Deliverable from './Deliverable'
import NewDeliverable from './NewDeliverable'



class Deliverables extends Component {

  state = {
    showNewDeliverableModal: false,
    dueDate: new Date().toISOString(),
    name: "",
    notes: "",
    analysts: [],
    status: "On Going",
  }

  _renderMenuItemChildren = (option, props, index) => {
    // THIS METHOD ENABLES CUSTOM HIGHLIGHT FIELDS ON CLIENT CONTACT SELECTION
    return [
      <div key="name" search={props.text}>
        <strong>{option.first_name} {option.last_name}</strong>
      </div>,
      <div key="population">
        <small>
          Email: {option.email ? option.email : "N/A"}
        </small>
      </div>,
    ]
  }

  handleSubmit = () => {
    if (this.state.dueDate && this.state.name && this.state.status) {

      const { currentUser, parentElement, parentElementName, route } = this.props

      const { name, description, notes, status, analysts, dueDate } = this.state

      swal({
        text: "Creating deliverable... Please stand by.",
        icon: require("../../static/images/spinner.gif"),
        button: false
      })

      const deliverable = {
        created_by: currentUser.url,
        name,
        description,
        notes,
        status,
        [parentElementName]: parentElement.url,
        analysts: analysts.map(user => user.url),
        due_date: new Date(dueDate).toJSON().split("T")[0]
      }

      axios({
        method:"POST",
        url:`${getServerURL()}${route}/`,
        headers:{"Authorization": "Bearer " + localStorage.getItem("token")},
        data: deliverable
      })
      .then(response => {
        // THERE IS NO KEY VALUE PAIR FOR DOCUMENTS AND IT MUST BE MANUALY ADDED
        // IN ORDER TO AVOID ISSUES UPLOADING THE FIRST DOCUMENT
        const newDeliverable = {
          ...response.data,
          ...deliverable,
          analysts,
          documents: [],
        }

        this.props.addDeliverable(newDeliverable)

        this.setState({
          showNewDeliverableModal: false,
          name: "",
          notes: "",
          analysts: [],
          status: "On Going",
          dueDate: new Date().toISOString()
        })

        swal({
          title: "Success",
          text: "The deliverable has been created",
          icon: "success",
          button: "Continue",
        })
      })
      .catch(error => {
        const message = `There was an error adding a deliverable to your ${parentElementName}`
        return handleErrorFetchingData(error, message)
      })
    } else {
      swal({
        title: "Error",
        text: "Please fill out all required fields",
        icon: "error",
        button: "Continue",
      })
    }
  }

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value })

  handleCancel = () => {
    this.setState({
      showNewDeliverableModal: !this.state.showNewDeliverableModal,
      dueDate: new Date().toISOString(),
      name: "",
      notes: "",
      analysts: [],
      status: "On Going",
    })
  }

  render () {
    const { parentElement, userOptions } = this.props

    const { showNewDeliverableModal, dueDate, name, notes, status, analysts  } = this.state

    let deliverables = parentElement.deliverables.sort((a,b) => {
      return new Date(b.created_date).getTime() - new Date(a.created_date).getTime()
    })

    // let userOptions = [...this.props.project.analysts, ...this.props.project.project_leads]
    let uniqueUserOptions = []
    let userMap = new Map()
    userOptions.forEach(user => {
      if (!userMap.has(user.id)) {
        userMap.set(user.id, true)
        uniqueUserOptions.push(user)
      }
    })

    return (
      <div id="ProjectDeliverables">
        <Button
          bsStyle={showNewDeliverableModal ? "default" : "primary"}
          onClick={this.handleCancel}
        >
          Add Deliverable
        </Button>
        <NewDeliverable
          show={showNewDeliverableModal}
          dueDate={dueDate}
          name={name}
          notes={notes}
          status={status}
          analysts={analysts}
          uniqueUserOptions={uniqueUserOptions}
          handleCancel={this.handleCancel}
          handleChange={this.handleChange}
          handleSubmit={this.handleSubmit}
          _renderMenuItemChildren={this._renderMenuItemChildren}
        />

        <Table responsive>
          <thead>
            <tr>
              <th>
                Deliverable:
              </th>
              <th>
                Due Date:
              </th>
              <th>
                Status:
              </th>
              <th>
                Assigned to:
              </th>
              <th>
                Documents:
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {deliverables.map(deliverable => {
              return (
                <Deliverable
                  key={deliverable.id}
                  parentElement={parentElement}
                  deliverable={deliverable}
                  documentRoute="deliverable-documents"
                  uniqueUserOptions={uniqueUserOptions}
                  _renderMenuItemChildren={this._renderMenuItemChildren}
                  editDeliverable={this.props.editDeliverable}
                  deleteDeliverable={this.props.deleteDeliverable}
                  addDeliverableDocument={this.props.addDeliverableDocument}
                  deleteDeliverableDocument={this.props.deleteDeliverableDocument}
                />
              )
            })}
          </tbody>
        </Table>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.manageLogin.user
  }
}

export default connect(mapStateToProps)(Deliverables)



// WEBPACK FOOTER //
// ./src/reuseable-components/deliverables/Deliverables.js